// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vJbp","top":"styles_top__2D0XZ"};